import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { Link } from 'base-ui'

import { useOpenableControls } from '../../../../generic-hooks'
import { priceAccessorGetDisplayPrice } from '../../../model/priceAccessor/priceAccessorGetDisplayPrice'
import { shippingAccessorGetCheappestShipping } from '../../../model/shippingAccessor/shippingAccessorGetCheappestShipping'
import { shippingAccessorGetFormattedShippingLeadTime } from '../../../model/shippingAccessor/shippingAccessorGetFormattedShippingLeadTime'
import { shippingAccessorGetFormattedShippingTypeCost } from '../../../model/shippingAccessor/shippingAccessorGetFormattedShippingTypeCost'
import { shippingAccessorGetShippingTypeCode } from '../../../model/shippingAccessor/shippingAccessorGetShippingTypeCode'
import { shippingAccessotGetDeliveryThresholdByCode } from '../../../model/shippingAccessor/shippingAccessotGetDeliveryThresholdByCode'
import { ProductDeliveryInfoDialog } from '../../ProductDeliveryInfoDialog'
import { useProductPageContext } from '../../productPageContext'
import { useProductStockStatus } from '../hooks/useProductStockStatus'

export const ProductBuyBoxMpDeliveryInfo: FC = () => {
  const {
    currentOffer,
    currentPrescriptionType,
    shipping: { marketplaceDeliveryCosts },
  } = useProductPageContext()
  const { handleClose, handleOpen, isOpen } = useOpenableControls(false)
  const stockStatus = useProductStockStatus()
  const intl = useIntl()

  if (
    !marketplaceDeliveryCosts ||
    marketplaceDeliveryCosts.length === 0 ||
    !currentOffer
  ) {
    return null
  }

  const cheapestDeliveryOption = shippingAccessorGetCheappestShipping(
    marketplaceDeliveryCosts,
  )

  const deliveryThreshold = shippingAccessotGetDeliveryThresholdByCode({
    code: shippingAccessorGetShippingTypeCode(cheapestDeliveryOption),
    shippings: currentOffer.shippings,
  })

  const productPrice = priceAccessorGetDisplayPrice(
    currentOffer,
    currentPrescriptionType,
  )?.price

  const isFreeShipping =
    typeof deliveryThreshold === 'number' &&
    typeof productPrice === 'number' &&
    productPrice >= deliveryThreshold

  const deliveryCostText = shippingAccessorGetFormattedShippingTypeCost({
    intl,
    isFreeShipping,
    shippingTypeCode: shippingAccessorGetShippingTypeCode(
      cheapestDeliveryOption,
    ),
    totalShippingPrice: cheapestDeliveryOption.totalShippingPrice,
  })

  const deliveryTimeText = shippingAccessorGetFormattedShippingLeadTime(
    intl,
    cheapestDeliveryOption.deliveryTime,
  )

  return (
    <div className="flex w-full flex-row items-center border-b border-b-dark-primary-min py-4">
      <div className={clsx('size-2 rounded-full', stockStatus.bgColor)} />
      <div className="flex-1 px-2">
        <div className="font-medium">{deliveryTimeText}</div>

        <div className="text-dark-primary-strong">{deliveryCostText}</div>
      </div>
      {marketplaceDeliveryCosts.length > 1 ? (
        <>
          <Link<'button'>
            color="inherit"
            onClick={handleOpen}
            slots={{ root: 'button' }}
            type="button"
          >
            <IconInfo
              className="mr-2 text-2xl text-dark-primary-strong"
              onClick={handleOpen}
            />
          </Link>
          <ProductDeliveryInfoDialog isOpen={isOpen} onClose={handleClose} />
        </>
      ) : null}
    </div>
  )
}
